module.exports = __webpack_public_path__ + "img/icon-03.2ca3aa05.png";